import { Undo } from 'ui/icons';
import { testIds } from '../../../constants';
import { useSideBySideEditorContext } from '../../../contexts/SideBySideEditorContext';
import { useTranslations } from '../../../hooks/useTranslations';
import { BaseEditButton } from './BaseEditButton';

export const UndoButton = () => {
  const { undo } = useSideBySideEditorContext();
  const { t } = useTranslations();

  return (
    <BaseEditButton
      onClick={undo}
      testId={testIds.toolbarBtnUndo}
      tooltip={t('tooltip.buttonUndo')}
    >
      <Undo />
    </BaseEditButton>
  );
};
